<template>
  <div class="table-wrapper" unselectable="on">
    <LoaderWait v-show="loading"/>
    <table class="main-table">
      <tr>
        <td colspan="2" class="td-row" style="height: 200px" width="70%" >
          <div class="input-head-text">
            <table style="border: 0; width: 100%; max-height: 200px;" cellpadding="0" cellspacing="0">
              <tr>
                <td rowspan="3" class="td-row">
                  <img src="/imgs/logo_impay.png">
                </td>
              </tr>
              <tr>
                <td style="padding-top: 30px; padding-left: 10px;">Баланс:</td>
                <td style="padding-top: 30px; text-align: right; width: 300px;">{{ user ? user.balance / 100.0 : 0.00 }}</td>
                <td style="padding-top: 30px; padding-left: 5px;">руб.</td>
              </tr>
              <tr>
                <td
                  colspan="3"
                  :style="'padding-top: 10px; padding-left: 10px; font-size: 26px;' + (user && user['identification_status'] == 1 ? 'color: green' : 'color: red')"
                >{{ identifyState }}</td>
              </tr>
            </table>
          </div>
        </td>
        <td class="td-row" width="30%" style="padding-bottom: 64px;">
          <div @click="historyClick" class="btn-prov" style="margin-top: 10px">
            <table>
              <tr>
                <td class="image-cell">
                  <img src="/imgs/op/group_6.png">
                </td>
                <td class="text-cell">
                  <div>История операций</div>
                </td>
              </tr>
            </table>
          </div>
          <div v-if="user && user['identification_status'] == 0" @click="backToIdentifyClick" class="btn-prov" style="margin-top: 10px;">
            <table>
              <tr>
                <td class="text-cell">
                  <div style="padding: 5px 40px;">Повторить регистрацию</div>
                </td>
              </tr>
            </table>
          </div>
          <!--<div v-if="user && user['identification_status'] == 2" @click="updateClick" class="btn-prov" style="margin-top: 10px;">
            <table>
              <tr>
                <td class="text-cell">
                  <div style="padding: 5px 40px;">Обновить</div>
                </td>
              </tr>
            </table>
          </div>-->
        </td>
      </tr>
      <tr>
        <td class="td-row" colspan="3" align="center">
          <table style="border: 0; width: 100%" cellpadding="8px">
            <tr v-for="(group, index) in providersPage" :key="index">
              <td width="30%" align="center">
                <div v-if="group.length > 0" @click="provClick(group[0].id)" class="btn-prov">
                  <table>
                    <tr>
                      <td class="image-cell">
                        <img :src="'/imgs/op/' + group[0].img ">
                      </td>
                      <td class="text-cell">
                        <div>{{ group[0].name }}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
              <td width="30%" align="center">
                <div v-if="group.length > 1" @click="provClick(group[1].id)" class="btn-prov">
                  <table>
                    <tr>
                      <td class="image-cell">
                        <img :src="'/imgs/op/' + group[1].img ">
                      </td>
                      <td class="text-cell">
                        <div>{{ group[1].name }}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
              <td width="30%" align="center">
                <div v-if="group.length > 2" @click="provClick(group[2].id)" class="btn-prov">
                  <table>
                    <tr>
                      <td class="image-cell">
                        <img :src="'/imgs/op/' + group[2].img ">
                      </td>
                      <td class="text-cell">
                        <div>{{ group[2].name }}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
          <img @click="backClick" src="/imgs/back_1.png" v-show="allowBack">
        </td>
        <td class="td-nav" width="40%" align="center">
          <img @click="exitClick" src="/imgs/menu_exit_1.png">
        </td>
        <td class="td-nav" width="30%" align="right">
          <img @click="fwdClick" src="/imgs/fwd_1.png" v-show="allowNext">
        </td>
      </tr>
    </table>
    <MessageBox :message="errorMessage" v-show="showMessage" :on-close="messageClose"></MessageBox>
    <SessionTimeout v-show="sessionTimeoutShow" :visible="sessionTimeoutShow" :on-close="onSessionClose"></SessionTimeout>
  </div>
</template>

<script>
import LoaderWait from "@/components/LoaderWait.vue";
import MessageBox from "@/components/MessageBox.vue";
import SessionTimeout from "@/components/SessionTimeout.vue";

export default {
  name: "MainPage",
  components: { SessionTimeout, MessageBox, LoaderWait },
  data () {
    return {
      loading: false,
      timer: null,
      timerUpdate: null,
      showMessage: false,
      errorMessage: '',
      page: 0,
      countProvs: 9,
      timeLeft: 180, // Время в секундах (3 минуты)
      timerIdentify: null,
      sessionTimeoutShow: false,
    }
  },
  computed: {
    user() {
      const data = this.$store.getters.GET_USER_PROFILE
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    providers () {
      const data = this.$store.getters.PROV_LIST
      if (data !== null) {
        return data;
      } else {
        return null
      }
    },
    providersPage () {
      const data = this.providers
      if (data !== null) {
        const grouped = [];
        for (let i = 0; i < this.countProvs && i < data.length; i += 3) {
          const start = this.page * this.countProvs + i;
          grouped.push(data.slice(start, start + 3));
        }
        return grouped;
      } else {
        return null
      }
    },
    identifyState () {
      if (this.user) {
        if (this.user['identification_status'] == 2) {
          return 'Статус: На проверке ' + this.formattedTime()
        } else if (this.user['identification_status'] == 1) {
          return 'Статус: Данные подтверждены'
        }
        return 'Данные не подтверждены. Повторите регистрацию заново'
      }
      return ''
    },
    allowBack () {
      if (this.providers != null) {
        return this.page > 0
      }
      return false
    },
    allowNext () {
      if (this.providers != null) {
        return this.providers.length > (this.page + 1) * this.countProvs
      }
      return false
    }
  },
  async mounted () {
    this.updateTimer()
    this.updateUserInfo().then(() => {
      if (this.user !== null && this.user['identification_status'] == 2) {
        this.startIdentifyTimer()
      }
    })
    await this.loadProvs();
  },
  methods: {
    async loadProvs() {
      this.loading = true
      this.$store.dispatch('GET_PROV_LIST', {
      }).then(() => {
        this.loading = false
      }).catch((e) => {
        this.loading = false
        if (e.response !== undefined && e.response.status === 401) {
          this.$store.dispatch('AUTH_LOGOUT')
        }
      })
    },
    async updateUserInfo(isHidden = false) {
      if (!this.user) {
        return;
      }
      if (!isHidden) {
        this.loading = true
      }

      await this.$store.dispatch('AUTH_CHECK_REQUEST', {
        phone: this.user.phone,
      }).then(() => {
        this.loading = false
        if (this.user !== null && this.user['identification_status'] != 2) {
          this.stopIdentifyTimer()
        }
      }).catch((e) => {
        this.loading = false
        if (e.response !== undefined && e.response.status === 401) {
          this.$store.dispatch('AUTH_LOGOUT')
        }
      })
    },
    updateTimer() {
      this.stopTimer()
      this.timer = setTimeout(() => this.showSessionEnd(), 60000)
      this.timerUpdate = setInterval(() => this.updateUserInfo(true), 15000)
    },
    stopTimer() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.timerUpdate !== null) {
        clearInterval(this.timerUpdate);
        this.timerUpdate = null;
      }
    },
    exitClick() {
      this.stopTimer()
      this.$store.dispatch('AUTH_LOGOUT')
    },
    provClick(id) {
      if (this.user['identification_status'] != 1) {
        this.updateTimer()
        this.messageShow('Ваши данные находятся на проверке. Для оплаты услуг связи, пожалуйста, дождитесь окончания. Проверка займет не более 2х минут.')
            .then(() => this.updateUserInfo())
      } else {
        this.stopTimer()
        console.log(id)
        this.$store.dispatch('SAVE_SELECT_PROV', {
          id: id,
        }).then(() => {
          this.$router.push('input-number')
        })
      }
    },
    historyClick() {
      this.stopTimer()
      this.$router.push('history')
    },
    messageShow(message) {
      this.showMessage = true;
      this.errorMessage = message;
      // Возвращаем Promise, который будет разрешён в messageClose
      return new Promise((resolve) => {
        this.messagePromiseResolver = resolve;
      });
    },
    messageClose() {
      this.showMessage = false;
      this.errorMessage = '';
      // Разрешаем Promise, если он существует
      if (this.messagePromiseResolver) {
        this.messagePromiseResolver();
        this.messagePromiseResolver = null;
      }
    },
    backClick() {
      this.updateTimer()
      if (this.page > 0) {
        this.page--
      }
    },
    fwdClick() {
      this.updateTimer()
      if (this.providers != null) {
        this.page++
      }
    },
    backToIdentifyClick() {
      this.stopTimer()
      this.$router.replace('identify')
    },
    startIdentifyTimer() {
      if (this.timerIdentify) return; // Если таймер уже работает, не запускаем заново

      this.timerIdentify = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          clearInterval(this.timerIdentify);
          this.timerIdentify = null;
          this.onTimerIdentifyEnd();
        }
      }, 1000);
    },
    onTimerIdentifyEnd() {
      //onTimerIdentifyEnd
    },
    stopIdentifyTimer() {
      if (this.timerIdentify !== null) {
        clearInterval(this.timerIdentify);
        this.timerIdentify = null;
      }
    },
    formattedTime() {
      if (this.timerIdentify !== null) {
        const minutes = Math.floor(this.timeLeft / 60);
        const seconds = this.timeLeft % 60;
        return `(${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")})`;
      }
      return ''
    },
    updateClick() {
      this.updateTimer()
      this.updateUserInfo()
    },
    showSessionEnd() {
      this.sessionTimeoutShow = true
    },
    onSessionClose(isContinue = false) {
      this.sessionTimeoutShow = false
      if (!isContinue) {
        this.exitClick()
      } else {
        this.updateTimer()
      }
    }
  }
}
</script>

<style scoped>
.btn-prov {
  display: block;
  background: url("../assets/imgs/btn_prov_tp_1.png") no-repeat;
  width: 381px;
  height: 114px;
}

.btn-prov table {
  width: 100%;
  height: 114px;
  border: none;
}

.image-cell {
  vertical-align: middle;
  width: 130px;
  padding: 0 5px;
}
.image-cell img {
  width: 100%;
  max-width: 130px;
  display: block;
}
.text-cell {
  vertical-align: middle;
  font-size: 24px;
  font-weight: 500;
  max-height: 108px;
  overflow: hidden;
  padding: 4px 5px;
}
.text-cell div {
  max-height: 108px;
  word-wrap: break-word;
  text-overflow: ellipsis;
}

</style>
